function getQueryFromFields(fields = []) {
  const query = fields.reduce((acc, field) => {
    if (field.value) {
      acc[field.reference] = field.value;
    }
    return acc;
  }, {});

  return query;
}

function getQueryFromVariants(variants = []) {
  const query = variants.reduce((acc, variant) => {
    if (variant.selectedOptionId) {
      acc[variant.reference] = variant.sku;
    }

    return acc;
  }, {});

  return query;
}

/**
 * creates a query object from payment values (current query, fields, variants)
 * used for redirects between checkouts and upsells
 */
export default function getRedirectQuery({
  payment = {},
  searchParams = {},
  query = {},
  iframeId = null,
} = {}) {
  if (searchParams) {
    delete searchParams['payment_intent'];
    delete searchParams['payment_intent_client_secret'];
    delete searchParams['redirect_status'];

    query = {
      ...query,
      ...searchParams,
    };
  }

  const fieldQuery = getQueryFromFields(payment.fields);

  const variantQuery = getQueryFromVariants(payment.variants);

  if (fieldQuery) {
    query = {
      ...query,
      ...fieldQuery,
      ...variantQuery,
      ...(iframeId ? { iframeId } : {}),
    };
  }

  return query;
}
